module.exports = __webpack_public_path__ + "img/hwy.b12e1d48.png";